module.exports = __webpack_public_path__ + "static/lunchtype22-regular-webfont-45c953b248850730da5847197250b301.eot";